import { LazyWrapper } from 'app/view/react_components/lazy/lazy_wrapper';
import React from 'react';
import { Provider } from "react-redux";
import { CardDetailsBaseView } from './base';

export const ChatsCardDetailsView = CardDetailsBaseView.extend({

    initialize: function (options) {
        CardDetailsBaseView.prototype.initialize.call(this, options);
        this.groupId = options.groupId;
        this.chatId = options.chatId;
        this.cardId = options.cardId;
        this.store = options.store;
        this.boardId = null;
    },

    asideClassName: 'card-chat',

    reactRender: function () {
        const store = this.store;
        const ImportElement = React.lazy(() =>
            this.initStore()
                .then(() => {
                    return import(/* webpackChunkName: "chatView" */ '../../react_components/main/chatView/store/chatView/reducers/chatViewReducer')
                        .then((module) => {
                            // store.reducerManager.add('chatView', module.chatViewReducer);
                            // store.dispatch({type: 'async-init'}); // fake action to init new reducers
                            return Promise.resolve();
                        })
                        .catch(e => console.error(e))
                })
                .then(() => import(/* webpackChunkName: "cardDetails" */ '../../react_components/aside_panel/assigneToMe/chats/hocs/ChatsCardHOC/ChatsCardHOC'))
                .then(module => ({default: module.ChatsCardHOC}))
                .catch(e => console.error(e))
        );

        this.root.render(
            <LazyWrapper>
                <Provider store={this.store}>
                    <ImportElement
                        groupId={this.groupId}
                        chatId={this.chatId}
                        cardId={this.cardId}
                    />
                </Provider>
            </LazyWrapper>
        );
    }

});
